import { Divider, HStack, Text, VStack } from '@chakra-ui/react';
import { AiFillBank } from 'react-icons/ai';

export default function BankInfo() {
  return (
    <>
      <HStack>
        <AiFillBank size={34} />
        <VStack
          display={{ base: 'none', md: 'flex' }}
          alignItems="flex-start"
          spacing="1px"
          ml="2"
        >
          <Text fontSize="sm">Alfyns BANK</Text>
          <Text fontSize="xs" color="gray.600">
            ID | 10008
          </Text>
        </VStack>
      </HStack>
      <Divider h='30px' orientation='vertical' />
    </>
  );
}
